import { Category } from 'models/category';
import Departments from 'models/departments';
import { isEmptyGeneralCategory } from './conditionsHelpers';
import { isHomeCategory } from './categoryHelpers';
import { getTopLevelCategoryFromUrl } from '../../../shared/helpers/url';

type ProductListTitleFactory = (
  departmentInternal: string,
  brandName?: string,
  selectedCategory?: Category,
  topLevelCategoryName?: string,
) => string;

const suffix = '| italist, ALWAYS LIKE A SALE';

export const productListTitleFactory: ProductListTitleFactory = (departmentInternal, brandName, selectedCategory) => {
  const realDepartmentInternal =
    departmentInternal && departmentInternal !== '' ? departmentInternal : Departments.getWomenInternalName();
  const departmentPossessiveNoun = Departments.getNameAsPossessiveNoun(realDepartmentInternal);
  const departmentName = Departments.getName(realDepartmentInternal);
  const subDepartmentPossessiveNoun = Departments.getNameAsPossessiveNoun(
    Departments.findInternalName(selectedCategory?.name),
  );
  const filteredBrandDepartmentTitle = Departments.filterBrandDepartmentTitle(brandName || '', departmentName);

  if (isEmptyGeneralCategory(selectedCategory)) {
    if (Departments.getHomeName() === selectedCategory?.name) {
      if (brandName) {
        return `${brandName} for ${Departments.getHomeName()} ${suffix}`;
      }
      return `${Departments.getHomeName()} ${suffix}`;
    }
    if (Departments.getKidsSubDepartmentsNames().includes(selectedCategory?.name)) {
      if (brandName) {
        return `${brandName} for ${selectedCategory.name} ${suffix}`;
      }
      return `${subDepartmentPossessiveNoun} Luxury Fashion ${suffix}`;
    }
    if (brandName) {
      return `${filteredBrandDepartmentTitle} ${suffix}`;
    }
    return `${departmentPossessiveNoun} Luxury Fashion ${suffix}`;
  }
  if (realDepartmentInternal === Departments.getKidsInternalName()) {
    const topLevelCategory = getTopLevelCategoryFromUrl(realDepartmentInternal, selectedCategory.url.substr(6));
    const topLevelCategoryName = Departments.getName(topLevelCategory);
    if (Departments.getKidsSubDepartmentsNames().includes(topLevelCategoryName)) {
      if (brandName) {
        return `${brandName} ${selectedCategory.name} for ${topLevelCategoryName} ${suffix}`;
      }
      return `${Departments.getNameAsPossessiveNoun(topLevelCategory)} ${selectedCategory.name} ${suffix}`;
    }
  }
  if (isHomeCategory(realDepartmentInternal, selectedCategory)) {
    if (brandName) {
      return `${brandName} ${selectedCategory.name} ${suffix}`;
    }
    return `${selectedCategory.name} ${suffix}`;
  }
  if (brandName) {
    return `${brandName} ${selectedCategory.name} for ${departmentName} ${suffix}`;
  }
  return `${departmentPossessiveNoun} ${selectedCategory.name} ${suffix}`;
};
